import React from 'react';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import EmailIcon from '@material-ui/icons/Email';
import Snackbar from '@material-ui/core/Snackbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SendIcon from '@material-ui/icons/Send';
import { trackFullStoryEvent } from '../../helper';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    width:'100%',
    marginBottom:24
  }
}));

const EmailNotificationRender = (props) => {
  const {
    snackbarOpen,
    setSnackbarOpen,
    currentPostmarkTemplate,
    setCurrentPostmarkTemplate,
    postmarkTemplates,
    sendEmail,
    hasEmail = true,
    sendToMail,
    sendTo
  } = props;
  const classes = useStyles();
  return (
    <div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        message="Message was sent successfully!"
      />
      {!!currentPostmarkTemplate &&
        postmarkTemplates &&
        !!Object.keys(postmarkTemplates).length && (
          <div>
            {/*<Typography gutterBottom>
              Select an email to send the customer from the list of configured
              email templates below
            </Typography>*/}
            <br />
            <Box display="flex" justifyContent="space-around" flexWrap="wrap" className="filter_items">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="text-template-email">Text Template</InputLabel>
                <Select
                  labelId="text-template-email"
                  style={{ float: 'left' }}
                  className="template-select"
                  value={
                    Object.entries(postmarkTemplates).find(
                      (template) => template[0] === currentPostmarkTemplate,
                    )[0]
                  }
                  onChange={(event) =>
                    setCurrentPostmarkTemplate(event.target.value)
                  }
                  label="Text Template"
                >
                  {Object.keys(postmarkTemplates).map((templateName) => (
                    <MenuItem key={templateName} value={templateName}>
                      {postmarkTemplates[templateName]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
              <Box className="communication_checkbox">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(sendTo.sendToUser != '' && sendTo.sendToUser !== 'admin') ? true : false}
                      name="sendToUser"
                      color="secondary"
                      value="customer"
                      onChange={(e) => sendToMail(e)}
                    />
                  }
                  className={(sendTo.sendToUser != '' && sendTo.sendToUser !== 'admin') ? 'checked' : ''}
                  label="Customer"
                />
              </Box>
              <Box className="communication_checkbox">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(sendTo.sendToUser != '' && sendTo.sendToUser !== 'customer') ? true : false}
                      name="sendToUser"
                      color="secondary"
                      value="admin"
                      onChange={(e) => sendToMail(e)}
                    />
                  }
                  className={(sendTo.sendToUser != '' && sendTo.sendToUser !== 'customer') ? 'checked' : false}
                  label="Admin"
                />
            </Box>
            <Box>
             
              <Button
                color="secondary"
                onClick={(e) => {
                  if (hasEmail) {
                    trackFullStoryEvent('CTA_Communications_Email_Send', {
                      template: currentPostmarkTemplate,
                      send_to: sendTo?.sendToUser,
                    });
                    sendEmail(e);
                  }
                }}
                variant="contained"
                className="send_btn"
              >
              Send
                <svg style={{ paddingLeft: '0.5em' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M2.925 5.025L9.18333 7.70833L2.91667 6.875L2.925 5.025ZM9.175 12.2917L2.91667 14.975V13.125L9.175 12.2917ZM1.25833 2.5L1.25 8.33333L13.75 10L1.25 11.6667L1.25833 17.5L18.75 10L1.25833 2.5Z" fill="#006C9C"/>
                  <path d="M3.12203 4.56546L2.4284 4.26806L2.42501 5.02275L2.41667 6.87275L2.41469 7.31265L2.85076 7.37064L9.11742 8.20397L9.38037 7.24879L3.12203 4.56546ZM9.37203 12.7512L9.109 11.796L2.85067 12.6294L2.41667 12.6872V13.125V14.975V15.7334L3.1137 15.4345L9.37203 12.7512ZM1.75725 16.7421L1.75063 12.1043L13.8161 10.4956V9.50439L1.75063 7.89566L1.75725 3.25795L17.4812 10L1.75725 16.7421Z" stroke="#00B8D9" stroke-opacity="0.16"/>
                </svg>
              </Button>
            </Box>
            {/*<Box display="flex" justifyContent="center" flexWrap="wrap">
              <Tooltip
                title={!hasEmail ? 'No email on file for customer.' : ''}
              >
                <Button
                  color="primary"
                  onClick={(e) => hasEmail && sendEmail(e, false)}
                  style={!hasEmail ? { color: 'rgba(0, 0, 0, 0.26)' } : {}}
                >
                  <EmailIcon style={{ paddingRight: '0.5em' }} />
                  Send Email To Customer
                </Button>
              </Tooltip>
              <Tooltip title="This will send an email to you, instead of the customer.">
                <Button color="primary" onClick={(e) => sendEmail(e, true)}>
                  <EmailIcon style={{ paddingRight: '0.5em' }} />
                  Send Email To Admin Inbox
                </Button>
              </Tooltip>
            </Box>*/}
          </div>
        )}
    </div>
  );
};

export default EmailNotificationRender;
